import { useState } from "react";
import { Paper, Chip, Box, Typography, Link as MuiLink } from "@mui/material";

export default function EventCard({ ev, index, gradient }) {
    const [hoverStyle, setHoverStyle] = useState({});

    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        const intensity = 22;

        setHoverStyle({
            transform: "translateY(-6px)",
            boxShadow: `${x / 18}px ${y / 18}px ${intensity}px rgba(0,0,0,0.25)`,
        });
    };

    const resetHover = () => setHoverStyle({});

    return (
        <Paper
            onMouseMove={handleMouseMove}
            onMouseLeave={resetHover}
            sx={{
                ...hoverStyle,
                transition: "all 0.25s ease",
                cursor: "default",
                p: 3,
                border: "1px solid #e5e5e5",
                borderRadius: 2,
                height: 260,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                position: "relative",

                opacity: 0,
                transform: "translateY(20px)",
                animation: "fadeInUp 0.6s ease forwards",
                animationDelay: `${index * 0.08}s`,

                "@keyframes fadeInUp": {
                    "0%": { opacity: 0, transform: "translateY(20px)" },
                    "100%": { opacity: 1, transform: "translateY(0)" },
                },
            }}
        >
            {/* Badge sport animé */}
            {ev.sport && (
                <Chip
                    label={ev.sport.toUpperCase()}
                    size="small"
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        color: "white",
                        fontWeight: 700,
                        fontSize: "0.7rem",
                        paddingX: 1,
                        background: `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`,
                        backgroundSize: "200% 200%",
                        animation: "gradientMove 4s ease infinite",
                        borderRadius: "6px",
                        boxShadow: `0 0 12px ${gradient.glow}`,

                        "@keyframes gradientMove": {
                            "0%": { backgroundPosition: "0% 50%" },
                            "50%": { backgroundPosition: "100% 50%" },
                            "100%": { backgroundPosition: "0% 50%" },
                        },
                    }}
                />
            )}

            <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {ev.nom}
                </Typography>
                <Typography sx={{ color: "text.secondary", mt: 1, mb: 2 }}>
                    {ev.date} — {ev.lieu}
                </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {ev.site_officiel && (
                    <MuiLink href={ev.site_officiel} target="_blank">
                        🔗 Site officiel
                    </MuiLink>
                )}
                {ev.startlist && (
                    <MuiLink href={ev.startlist} target="_blank">
                        📄 Liste de départ
                    </MuiLink>
                )}
                {ev.resultats && (
                    <MuiLink href={ev.resultats} target="_blank">
                        🏁 Résultats
                    </MuiLink>
                )}
                {ev.livetiming && (
                    <MuiLink href={ev.livetiming} target="_blank" color="secondary.main">
                        ⏱️ LiveTiming
                    </MuiLink>
                )}
            </Box>
        </Paper>
    );
}
